import React from 'react';
import PropTypes from 'prop-types';
import { ActionIcon, Select } from '@mantine/core';
import { Trash } from 'tabler-icons-react';
import AppFlexbox from '../../common/AppFlexbox';
import { ECOM_PRODUCT_PRICING_TYPE_ENUM } from '../../../config/constants';
import AppText from '../../common/AppText';
import CustomNumberInput from '../../common/CustomNumberInput';
import AppStack from '../../common/AppStack';

const StoreBundlePricingEditControls = ({
  title,
  onRemove,
  onChange,
  disabled,
  pricing
}) => {
  const {
    pricingAmountOverride,
    roundingAdjustmentOverride,
    fkEcomPricingType
  } = pricing || {};

  const isPercentagePricing =
    fkEcomPricingType === ECOM_PRODUCT_PRICING_TYPE_ENUM.PERCENTAGE_ADJUSTMENT;

  return (
    <>
      {(title || onRemove) && (
        <AppFlexbox
          style={{
            gap: 8,
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {title && (
            <AppText style={{ fontSize: 15, fontWeight: 700 }}>{title}</AppText>
          )}
          {onRemove && (
            <ActionIcon
              color="#C40000"
              onClick={onRemove}
              size="sm"
              variant="subtle"
            >
              <Trash color="#C40000" size={16} />
            </ActionIcon>
          )}
        </AppFlexbox>
      )}

      <AppFlexbox style={{ flex: 1, gap: 8 }}>
        <AppStack style={{ flex: 1 }}>
          <Select
            data={[
              {
                value: ECOM_PRODUCT_PRICING_TYPE_ENUM.PERCENTAGE_ADJUSTMENT,
                label: 'Percentage Adjustment'
              }
            ]}
            disabled={disabled}
            label="Type"
            onChange={(v) => {
              onChange({
                ...pricing,
                fkEcomPricingType: v
              });
            }}
            required
            style={{ flex: 1 }}
            value={fkEcomPricingType}
          />
        </AppStack>

        <AppStack style={{ flex: 1 }}>
          <CustomNumberInput
            allowNegative={false}
            decimalScale={2}
            disabled={disabled}
            fixedDecimalScale
            label={`Margin (in ${isPercentagePricing ? '%' : '$'})`}
            leftSection={
              !isPercentagePricing && (
                <AppText
                  style={{
                    fontWeight: 500,
                    color: '#666',
                    fontSize: 14
                  }}
                >
                  $
                </AppText>
              )
            }
            onChange={(v) =>
              onChange({
                ...pricing,
                pricingAmountOverride: v
              })
            }
            placeholder="30.00"
            required
            rightSection={
              isPercentagePricing ? (
                <AppText
                  style={{
                    fontWeight: 500,
                    color: '#666',
                    fontSize: 14
                  }}
                >
                  %
                </AppText>
              ) : (
                <></>
              )
            }
            value={pricingAmountOverride}
          />
        </AppStack>

        <AppStack style={{ flex: 1 }}>
          <CustomNumberInput
            allowNegative={false}
            clampBehavior="strict"
            decimalScale={0}
            disabled={disabled}
            fixedDecimalScale
            label="Rounding Adjustment (in cents)"
            max={99}
            min={0}
            onChange={(v) => {
              onChange({
                ...pricing,
                roundingAdjustmentOverride: v > 99 ? 99 : v
              });
            }}
            placeholder=".95"
            required
            value={
              roundingAdjustmentOverride > 99 ? 99 : roundingAdjustmentOverride
            }
          />
        </AppStack>
      </AppFlexbox>
    </>
  );
};

StoreBundlePricingEditControls.propTypes = {
  allowFreeGift: PropTypes.bool,
  disabled: PropTypes.bool,
  includeQuantitySelect: PropTypes.bool,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  pricing: PropTypes.object,
  title: PropTypes.string
};

export default StoreBundlePricingEditControls;
